import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Icon } from 'semantic-ui-react';
import { TranslatableString } from '@rjsf/utils';
/** The `AddButton` renders a button that represent the `Add` action on a form
 */
export default function AddButton({ uiSchema, registry, color, ...props }) {
    const { translateString } = registry;
    return (_jsx(Button, { title: translateString(TranslatableString.AddItemButton), color: color, ...props, icon: true, size: 'tiny', children: _jsx(Icon, { name: 'plus' }) }));
}
//# sourceMappingURL=AddButton.js.map